var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2278_14717)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 24,
    rx: 12,
    fill: "#5D6C7B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#E7F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18C9.05228 18 9.5 18.4477 9.5 19C9.5 19.5523 9.05228 20 8.5 20C7.94772 20 7.5 19.5523 7.5 19C7.5 18.4477 7.94772 18 8.5 18Z",
    fill: "#C4D8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10C15.3807 10 16.5 11.1193 16.5 12.5C16.5 13.8807 15.3807 15 14 15C12.6193 15 11.5 13.8807 11.5 12.5C11.5 11.1193 12.6193 10 14 10Z",
    fill: "#C4D8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 9C7.60457 9 8.5 9.89543 8.5 11C8.5 12.1046 7.60457 13 6.5 13C5.39543 13 4.5 12.1046 4.5 11C4.5 9.89543 5.39543 9 6.5 9Z",
    fill: "#C4D8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4C16.8284 4 17.5 4.67157 17.5 5.5C17.5 6.32843 16.8284 7 16 7C15.1716 7 14.5 6.32843 14.5 5.5C14.5 4.67157 15.1716 4 16 4Z",
    fill: "#C4D8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 12.4229L33.6925 11.4998L34.6157 7.80722L35.5388 11.4998L39.2313 12.4229L35.5388 13.346L34.6157 17.0386L33.6925 13.346L30 12.4229Z",
    fill: "#E7F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 18.5L45.4617 17.8845L46.0771 15.4228L46.6925 17.8845L49.1542 18.5L46.6925 19.1154L46.0771 21.5771L45.4617 19.1154L43 18.5Z",
    fill: "#E7F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 4.73075L40.8463 4.26918L41.3078 2.42291L41.7694 4.26918L43.6157 4.73075L41.7694 5.19232L41.3078 7.03859L40.8463 5.19232L39 4.73075Z",
    fill: "#E7F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19.423L26.2308 19.1153L26.5386 17.8844L26.8463 19.1153L28.0771 19.423L26.8463 19.7307L26.5386 20.9616L26.2308 19.7307L25 19.423Z",
    fill: "#E7F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.7275 4C-26.9202 4 -25.4542 5.46511 -25.4541 7.27246C-25.4541 8.11501 -25.7758 8.88087 -26.2988 9.46094C-23.5752 9.58216 -21.3725 11.7 -21.1172 14.3867C-20.0861 14.0189 -18.9757 13.8184 -17.8184 13.8184C-12.5635 13.8184 -8.27286 17.9465 -8.0127 23.1367C-7.36804 22.7609 -6.61836 22.5459 -5.81836 22.5459C-3.49129 22.5459 -1.58999 24.3671 -1.46191 26.6621C-0.881802 26.1389 -0.115185 25.8184 0.727539 25.8184C2.53487 25.8185 3.99995 27.2835 4 29.0908C4 30.8982 2.53489 32.3631 0.727539 32.3633C-0.864143 32.3633 -2.19037 31.2273 -2.48438 29.7217C-3.28482 30.6695 -4.48063 31.2725 -5.81836 31.2725C-7.45293 31.2724 -8.87653 30.3733 -9.62402 29.043C-11.381 31.7004 -14.3941 33.4541 -17.8184 33.4541C-23.2406 33.454 -27.6365 29.0589 -27.6367 23.6367C-27.6367 22.4794 -27.4351 21.3689 -27.0674 20.3379C-29.8349 20.0751 -31.9999 17.7455 -32 14.9092C-32 13.045 -31.0644 11.3998 -29.6377 10.416C-31.0021 10.0215 -32 8.7639 -32 7.27246C-31.9999 5.46519 -30.5348 4.00014 -28.7275 4Z",
    fill: "#E7F2FC",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2278_14717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.b60a5c6c99491797bb520c6c980ab9b0.svg";
export { ForwardRef as ReactComponent };